var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSh7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "720px",
    height: "720px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M -0.5,-0.5 C 239.5,-0.5 479.5,-0.5 719.5,-0.5C 719.5,239.5 719.5,479.5 719.5,719.5C 479.5,719.5 239.5,719.5 -0.5,719.5C -0.5,479.5 -0.5,239.5 -0.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ef3030",
    d: "M 506.5,125.5 C 507.992,129.818 509.992,133.818 512.5,137.5C 518.328,153.809 521.662,170.642 522.5,188C 522.458,201.427 519.792,214.261 514.5,226.5C 511.992,230.182 509.992,234.182 508.5,238.5C 497.189,256.44 486.356,274.774 476,293.5C 471.34,309.141 466.84,324.808 462.5,340.5C 459.659,344.849 457.326,349.516 455.5,354.5C 447.365,366.565 438.365,378.065 428.5,389C 455.053,398.036 476.22,414.203 492,437.5C 498.112,447.399 503.946,457.399 509.5,467.5C 511.766,474.037 514.6,480.371 518,486.5C 518.483,485.552 518.649,484.552 518.5,483.5C 520.592,480.912 521.925,477.912 522.5,474.5C 526.341,468.151 529.675,461.484 532.5,454.5C 540.021,441.972 548.354,429.972 557.5,418.5C 562.833,413.833 567.833,408.833 572.5,403.5C 578.844,398.324 585.844,394.158 593.5,391C 597.868,389.541 600.868,390.874 602.5,395C 595.448,407.483 589.948,420.65 586,434.5C 577.844,462.789 569.844,491.122 562,519.5C 561.215,521.286 560.049,522.786 558.5,524C 555.064,524.692 551.73,525.692 548.5,527C 551.728,528.563 553.895,531.063 555,534.5C 556.449,554.971 561.615,574.304 570.5,592.5C 572.46,599.086 575.46,605.086 579.5,610.5C 579.66,612.153 580.326,613.486 581.5,614.5C 583.597,619.689 585.93,624.689 588.5,629.5C 588.838,632.157 588.171,634.49 586.5,636.5C 582.892,637.593 579.225,637.76 575.5,637C 568.512,634.165 562.179,630.331 556.5,625.5C 548.833,617.167 540.833,609.167 532.5,601.5C 521.044,587.539 509.377,573.706 497.5,560C 495.112,558.139 492.446,556.806 489.5,556C 479.426,554.119 469.259,553.285 459,553.5C 438.029,553.624 417.196,554.957 396.5,557.5C 391.456,557.173 386.456,557.506 381.5,558.5C 385.836,564.86 387.503,571.86 386.5,579.5C 381.28,585.95 374.947,587.117 367.5,583C 360.218,578.441 353.385,573.274 347,567.5C 344.454,564.14 342.621,560.474 341.5,556.5C 314.372,553.011 288.372,545.678 263.5,534.5C 259.653,531.407 255.32,529.074 250.5,527.5C 238.184,519.335 226.184,510.669 214.5,501.5C 209.833,496.167 204.833,491.167 199.5,486.5C 196.514,482.183 193.18,478.183 189.5,474.5C 188.235,471.475 186.568,468.642 184.5,466C 181.087,465.529 178.087,466.362 175.5,468.5C 170.358,469.542 165.691,471.542 161.5,474.5C 156.749,475.71 152.416,477.71 148.5,480.5C 147.508,480.328 146.842,480.662 146.5,481.5C 141.68,483.074 137.347,485.407 133.5,488.5C 111.408,500.075 89.408,511.909 67.5,524C 63.4528,526.073 59.6195,525.907 56,523.5C 55.7043,517.641 56.7043,511.974 59,506.5C 64.6447,494.541 71.3113,483.207 79,472.5C 87.268,461.621 95.768,450.954 104.5,440.5C 110.5,435.167 116.167,429.5 121.5,423.5C 134.521,413.662 147.854,404.328 161.5,395.5C 163.467,387.903 164.134,379.903 163.5,371.5C 165.457,348.55 170.29,326.217 178,304.5C 179.086,281.753 178.252,259.086 175.5,236.5C 177.255,235.928 178.922,235.094 180.5,234C 178.236,233.764 176.069,233.264 174,232.5C 173.827,226.652 173.327,220.985 172.5,215.5C 171.974,209.392 170.807,203.392 169,197.5C 164.663,185.156 160.33,172.822 156,160.5C 154.431,155.375 155.931,151.541 160.5,149C 172.745,150.194 184.078,154.194 194.5,161C 213.142,173.307 227.975,189.141 239,208.5C 240.704,206.627 242.537,204.96 244.5,203.5C 247.5,201.167 250.167,198.5 252.5,195.5C 261.482,188.858 270.482,182.191 279.5,175.5C 284.469,172.522 289.135,169.189 293.5,165.5C 343.361,136.602 397.028,118.769 454.5,112C 464.5,111.333 474.5,111.333 484.5,112C 488.653,112.384 492.653,113.384 496.5,115C 500.178,118.203 503.511,121.703 506.5,125.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#330404",
    d: "M 452.5,118.5 C 459.989,117.344 467.655,117.178 475.5,118C 473.846,118.608 472.179,119.108 470.5,119.5C 464.69,118.51 458.69,118.177 452.5,118.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#070000",
    d: "M 452.5,118.5 C 458.69,118.177 464.69,118.51 470.5,119.5C 467.68,121.745 464.68,123.745 461.5,125.5C 455.833,129.167 451.167,133.833 447.5,139.5C 438.824,144.106 429.49,146.439 419.5,146.5C 415.56,146.758 411.893,147.924 408.5,150C 407.748,150.671 407.414,151.504 407.5,152.5C 404.939,154.64 402.605,156.973 400.5,159.5C 396.072,166.019 392.406,173.019 389.5,180.5C 384.83,188.829 377.83,191.662 368.5,189C 364.67,194.989 360.67,200.822 356.5,206.5C 351.895,209.436 347.895,213.102 344.5,217.5C 340.629,221.272 335.962,223.772 330.5,225C 320.668,226.249 311.001,228.249 301.5,231C 292.961,235.43 284.961,240.596 277.5,246.5C 273.5,248.5 270.5,251.5 268.5,255.5C 257.306,263.548 249.806,274.215 246,287.5C 245.333,289.833 245.333,292.167 246,294.5C 247.992,303.469 249.826,312.469 251.5,321.5C 250.927,340.737 241.26,352.404 222.5,356.5C 222.006,358.026 221.339,359.359 220.5,360.5C 216.674,367.671 211.674,374.004 205.5,379.5C 197.902,385.644 189.569,390.81 180.5,395C 176.008,397.998 171.675,401.165 167.5,404.5C 163.833,406.167 161.167,408.833 159.5,412.5C 158.833,412.5 158.5,412.833 158.5,413.5C 154.229,416.101 150.563,419.434 147.5,423.5C 139.899,428.644 132.232,433.81 124.5,439C 118.259,444.737 112.592,450.903 107.5,457.5C 102.56,460.77 98.2269,464.77 94.5,469.5C 88.1892,474.969 81.6892,480.302 75,485.5C 74.8333,485.167 74.6667,484.833 74.5,484.5C 81.7485,472.663 90.4151,461.996 100.5,452.5C 103.167,450.5 105.5,448.167 107.5,445.5C 126.161,426.83 146.828,410.83 169.5,397.5C 175.167,393.833 179.833,389.167 183.5,383.5C 186.442,379.277 188.609,374.61 190,369.5C 190.798,367.741 190.631,366.074 189.5,364.5C 187.807,371.017 184.64,376.684 180,381.5C 175.333,385.5 170.667,389.5 166,393.5C 165.641,386.64 166.141,379.974 167.5,373.5C 168.801,369.057 169.468,364.391 169.5,359.5C 178.556,305.387 201.89,258.721 239.5,219.5C 246.5,213.167 253.167,206.5 259.5,199.5C 268.91,189.97 279.243,181.636 290.5,174.5C 296.852,170.993 302.852,166.993 308.5,162.5C 310.336,160.412 312.669,159.079 315.5,158.5C 319.655,157.258 323.322,155.258 326.5,152.5C 326.842,151.662 327.508,151.328 328.5,151.5C 332.582,150.624 336.249,148.957 339.5,146.5C 375.304,130.133 412.97,120.799 452.5,118.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#030000",
    d: "M 496.5,125.5 C 498.916,130.667 501.582,135.667 504.5,140.5C 508.213,148.338 510.546,156.672 511.5,165.5C 511.717,171.36 512.383,177.027 513.5,182.5C 513.775,190.553 513.275,198.553 512,206.5C 511.399,210.952 509.899,214.952 507.5,218.5C 503.992,224.182 500.992,230.182 498.5,236.5C 498.672,237.492 498.338,238.158 497.5,238.5C 496.035,239.406 495.035,240.739 494.5,242.5C 493.051,243.172 491.718,243.839 490.5,244.5C 484.117,251.527 476.117,255.693 466.5,257C 441.914,261.799 417.914,259.799 394.5,251C 383.107,244.978 372.107,238.478 361.5,231.5C 359.193,229.953 356.527,229.287 353.5,229.5C 351.304,229.505 349.304,229.838 347.5,230.5C 341.359,233.292 336.026,237.292 331.5,242.5C 332.7,243.292 334.033,243.292 335.5,242.5C 338.537,240.814 339.87,241.814 339.5,245.5C 335.079,262.659 335.579,279.659 341,296.5C 343.328,300.98 345.828,305.313 348.5,309.5C 350.167,313.167 352.833,315.833 356.5,317.5C 371.746,328.75 388.913,334.75 408,335.5C 428.067,334.3 443.067,324.967 453,307.5C 460.27,294.023 464.937,279.69 467,264.5C 472.568,261.966 478.068,259.3 483.5,256.5C 484.376,256.369 485.043,256.702 485.5,257.5C 483.962,259.243 482.962,261.243 482.5,263.5C 477.422,272.654 472.589,281.987 468,291.5C 464.65,303.245 461.483,314.912 458.5,326.5C 456.595,330.216 455.261,334.216 454.5,338.5C 451.819,346.196 448.319,353.529 444,360.5C 426.347,386.491 404.681,407.824 379,424.5C 380.011,423.663 381.178,423.33 382.5,423.5C 387.086,422.54 391.086,420.54 394.5,417.5C 398.432,414.521 402.432,411.521 406.5,408.5C 408.028,409.861 409.695,411.028 411.5,412C 418.085,412.749 424.419,414.416 430.5,417C 435.833,421 440.5,425.667 444.5,431C 447.952,431.885 451.286,432.718 454.5,433.5C 458.097,435.756 461.431,438.423 464.5,441.5C 465.79,442.058 466.623,443.058 467,444.5C 468.787,453.779 471.454,462.779 475,471.5C 476.5,473 478,474.5 479.5,476C 488.107,479.302 496.107,483.635 503.5,489C 506.729,493.233 509.562,497.733 512,502.5C 515.962,506.642 520.296,510.308 525,513.5C 525.757,515.315 526.59,516.981 527.5,518.5C 527.03,519.693 526.03,520.36 524.5,520.5C 521.024,519.896 517.691,518.896 514.5,517.5C 512.745,516.928 511.078,516.094 509.5,515C 489.354,495.438 466.688,479.605 441.5,467.5C 437.915,465.194 433.915,463.861 429.5,463.5C 414.381,459.81 399.047,458.643 383.5,460C 377.86,461.545 372.694,464.045 368,467.5C 364.137,473.985 365.137,479.652 371,484.5C 370.123,491.588 372.957,496.422 379.5,499C 383.805,500.015 388.139,500.848 392.5,501.5C 395.628,508.298 400.628,512.965 407.5,515.5C 408.209,516.404 409.209,516.737 410.5,516.5C 411.087,521.001 412.754,525.001 415.5,528.5C 420.753,538.785 417.42,543.285 405.5,542C 401.8,541.157 398.8,539.324 396.5,536.5C 393.875,533.185 390.542,530.851 386.5,529.5C 382.679,528.088 379.013,526.422 375.5,524.5C 374.379,526.089 374.546,527.756 376,529.5C 378.766,532.777 381.933,535.443 385.5,537.5C 394.737,541.524 404.237,544.857 414,547.5C 421.095,546.878 424.929,543.045 425.5,536C 424.59,532.015 423.257,528.182 421.5,524.5C 420.457,521.944 418.79,519.777 416.5,518C 416.728,517.601 417.062,517.435 417.5,517.5C 426.409,517.596 435.076,519.096 443.5,522C 451.5,527.333 459.5,532.667 467.5,538C 471.395,539.266 475.395,539.766 479.5,539.5C 480.873,539.657 482.207,539.49 483.5,539C 485.734,537.25 488.068,535.75 490.5,534.5C 495.854,537.011 500.187,540.844 503.5,546C 504.094,546.464 504.761,546.631 505.5,546.5C 515.696,546.746 525.696,548.246 535.5,551C 541.145,553.8 544.145,558.3 544.5,564.5C 543.776,567.827 543.61,571.161 544,574.5C 548.714,577.691 553.714,580.357 559,582.5C 566.128,599.422 574.294,615.755 583.5,631.5C 580.894,632.652 578.227,632.818 575.5,632C 568.561,629.043 562.561,624.876 557.5,619.5C 554.769,615.766 551.436,612.766 547.5,610.5C 544.5,608.167 541.833,605.5 539.5,602.5C 536.899,598.229 533.566,594.563 529.5,591.5C 519.366,580.528 509.366,569.361 499.5,558C 491.86,553.339 483.527,551.006 474.5,551C 464,550.833 453.5,550.667 443,550.5C 415.837,551.489 388.67,551.989 361.5,552C 306.577,549.59 257.91,531.257 215.5,497C 212.629,494.297 209.962,491.464 207.5,488.5C 205.761,485.757 203.427,483.757 200.5,482.5C 199.5,481.167 198.5,479.833 197.5,478.5C 195.913,475.732 194.08,473.065 192,470.5C 191.506,468.866 191.34,467.199 191.5,465.5C 191.414,464.504 191.748,463.671 192.5,463C 194.392,462.027 196.392,461.36 198.5,461C 205.574,459.659 212.574,459.159 219.5,459.5C 205.026,456.413 190.692,457.246 176.5,462C 165.927,465.291 155.594,469.124 145.5,473.5C 138.248,475.793 131.581,479.126 125.5,483.5C 104.557,496.312 83.2232,508.645 61.5,520.5C 61.6868,505.625 67.6868,493.458 79.5,484C 91.1945,476.807 101.861,468.307 111.5,458.5C 115.234,455.769 118.234,452.436 120.5,448.5C 128.835,439.172 138.835,432.172 150.5,427.5C 157.11,422.559 163.11,416.892 168.5,410.5C 170.628,407.87 172.961,405.37 175.5,403C 186.167,396.667 196.833,390.333 207.5,384C 212.362,380.303 216.696,376.136 220.5,371.5C 223.248,368.345 225.248,364.678 226.5,360.5C 227.949,359.828 229.282,359.161 230.5,358.5C 249.082,350.391 256.915,336.057 254,315.5C 251.456,307.489 249.622,299.323 248.5,291C 249.375,283.038 252.208,275.871 257,269.5C 268.946,257.214 281.78,246.047 295.5,236C 306.894,230.727 318.894,227.894 331.5,227.5C 336.232,227.373 340.232,225.707 343.5,222.5C 351.5,216.5 358.5,209.5 364.5,201.5C 366.833,198.833 369.167,196.167 371.5,193.5C 382.198,193.57 390.031,188.904 395,179.5C 398.297,172.25 401.964,165.25 406,158.5C 407.873,156.291 410.04,154.458 412.5,153C 420.947,150.146 429.613,148.146 438.5,147C 441.618,145.941 444.618,144.608 447.5,143C 453.5,137.333 459.5,131.667 465.5,126C 474.264,117.843 483.93,116.51 494.5,122C 495.823,122.816 496.489,123.983 496.5,125.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3b0505",
    d: "M 506.5,125.5 C 509.54,128.914 511.54,132.914 512.5,137.5C 509.992,133.818 507.992,129.818 506.5,125.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#320303",
    d: "M 461.5,125.5 C 457.167,130.5 452.5,135.167 447.5,139.5C 451.167,133.833 455.833,129.167 461.5,125.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#340404",
    d: "M 496.5,125.5 C 500.455,129.74 503.122,134.74 504.5,140.5C 501.582,135.667 498.916,130.667 496.5,125.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#340403",
    d: "M 339.5,146.5 C 336.249,148.957 332.582,150.624 328.5,151.5C 331.751,149.043 335.418,147.376 339.5,146.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#360404",
    d: "M 419.5,146.5 C 415.287,147.94 411.287,149.94 407.5,152.5C 407.414,151.504 407.748,150.671 408.5,150C 411.893,147.924 415.56,146.758 419.5,146.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#310303",
    d: "M 326.5,152.5 C 323.322,155.258 319.655,157.258 315.5,158.5C 318.678,155.742 322.345,153.742 326.5,152.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#070000",
    d: "M 210.5,241.5 C 206.844,244.803 204.178,248.803 202.5,253.5C 196.576,263.681 190.909,274.014 185.5,284.5C 184.778,284.918 184.278,285.584 184,286.5C 183.831,274.993 183.331,263.659 182.5,252.5C 181.366,248.164 181.366,243.831 182.5,239.5C 187.167,236.5 191.833,233.5 196.5,230.5C 191.232,229.129 185.898,228.129 180.5,227.5C 180.153,218.728 178.987,210.061 177,201.5C 172.16,186.979 167.326,172.479 162.5,158C 162.833,156.833 163.167,155.667 163.5,154.5C 192.301,162.795 215.467,179.128 233,203.5C 235,207.167 235,210.833 233,214.5C 225.259,223.398 217.759,232.398 210.5,241.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#360404",
    d: "M 308.5,162.5 C 302.852,166.993 296.852,170.993 290.5,174.5C 295.803,169.511 301.803,165.511 308.5,162.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ed2f2f",
    d: "M 333.5,165.5 C 334.458,166.962 335.624,168.295 337,169.5C 337.667,170.167 337.667,170.833 337,171.5C 335.416,170.139 333.582,169.472 331.5,169.5C 326.087,167.896 320.753,168.396 315.5,171C 312.833,174.333 310.167,177.667 307.5,181C 306.517,181.591 305.85,181.257 305.5,180C 306.755,177.078 308.422,174.411 310.5,172C 315.365,167.982 320.865,165.482 327,164.5C 329.216,164.653 331.383,164.986 333.5,165.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#390505",
    d: "M 293.5,165.5 C 289.135,169.189 284.469,172.522 279.5,175.5C 279.414,174.504 279.748,173.671 280.5,173C 284.562,169.971 288.895,167.471 293.5,165.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#310303",
    d: "M 400.5,159.5 C 397.594,166.981 393.928,173.981 389.5,180.5C 392.406,173.019 396.072,166.019 400.5,159.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#370404",
    d: "M 333.5,165.5 C 337.093,166.43 338.759,168.763 338.5,172.5C 335.759,172.293 333.426,171.293 331.5,169.5C 333.582,169.472 335.416,170.139 337,171.5C 337.667,170.833 337.667,170.167 337,169.5C 335.624,168.295 334.458,166.962 333.5,165.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#360404",
    d: "M 511.5,165.5 C 513.117,170.916 513.784,176.583 513.5,182.5C 512.383,177.027 511.717,171.36 511.5,165.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ee3030",
    d: "M 337.5,192.5 C 337.66,194.199 337.494,195.866 337,197.5C 331.177,188.588 324.843,188.255 318,196.5C 316.384,200.347 315.384,204.347 315,208.5C 314.148,207.429 313.315,206.429 312.5,205.5C 311.176,192.553 316.843,186.053 329.5,186C 332.961,187.305 335.628,189.471 337.5,192.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#300503",
    d: "M 337.5,192.5 C 338.461,194.265 338.795,196.265 338.5,198.5C 336.678,198.831 335.011,199.498 333.5,200.5C 334.749,198.171 334.082,196.338 331.5,195C 320.958,193.835 315.958,198.668 316.5,209.5C 313.5,209.833 312.167,208.5 312.5,205.5C 313.315,206.429 314.148,207.429 315,208.5C 315.384,204.347 316.384,200.347 318,196.5C 324.843,188.255 331.177,188.588 337,197.5C 337.494,195.866 337.66,194.199 337.5,192.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f23131",
    d: "M 333.5,200.5 C 326.689,202.899 327.023,203.899 334.5,203.5C 337.082,209.23 335.415,213.73 329.5,217C 323.215,218.524 318.882,216.358 316.5,210.5C 316.5,210.167 316.5,209.833 316.5,209.5C 315.958,198.668 320.958,193.835 331.5,195C 334.082,196.338 334.749,198.171 333.5,200.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3a0505",
    d: "M 371.5,193.5 C 369.167,196.167 366.833,198.833 364.5,201.5C 365.723,198.726 367.223,196.059 369,193.5C 369.977,192.226 370.811,192.226 371.5,193.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#360404",
    d: "M 252.5,195.5 C 250.167,198.5 247.5,201.167 244.5,203.5C 246.167,199.833 248.833,197.167 252.5,195.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#330403",
    d: "M 259.5,199.5 C 253.167,206.5 246.5,213.167 239.5,219.5C 239.369,218.761 239.536,218.094 240,217.5C 246.09,210.904 252.59,204.904 259.5,199.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#330403",
    d: "M 356.5,206.5 C 353.105,210.898 349.105,214.564 344.5,217.5C 347.895,213.102 351.895,209.436 356.5,206.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#380505",
    d: "M 334.5,203.5 C 335.5,203.5 336.5,203.5 337.5,203.5C 337.584,216.258 331.584,220.758 319.5,217C 317.549,215.266 316.549,213.099 316.5,210.5C 318.882,216.358 323.215,218.524 329.5,217C 335.415,213.73 337.082,209.23 334.5,203.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#330404",
    d: "M 172.5,215.5 C 173.327,220.985 173.827,226.652 174,232.5C 176.069,233.264 178.236,233.764 180.5,234C 178.922,235.094 177.255,235.928 175.5,236.5C 175.611,235.883 175.944,235.383 176.5,235C 175.234,234.691 174.067,234.191 173,233.5C 172.501,227.509 172.334,221.509 172.5,215.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#350404",
    d: "M 343.5,222.5 C 340.232,225.707 336.232,227.373 331.5,227.5C 335.424,225.853 339.424,224.186 343.5,222.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#340403",
    d: "M 507.5,218.5 C 505.54,225.086 502.54,231.086 498.5,236.5C 500.992,230.182 503.992,224.182 507.5,218.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#370404",
    d: "M 347.5,230.5 C 349.304,229.838 351.304,229.505 353.5,229.5C 356.527,229.287 359.193,229.953 361.5,231.5C 356.881,230.686 352.214,230.353 347.5,230.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ef3030",
    d: "M 347.5,230.5 C 352.214,230.353 356.881,230.686 361.5,231.5C 372.107,238.478 383.107,244.978 394.5,251C 417.914,259.799 441.914,261.799 466.5,257C 476.117,255.693 484.117,251.527 490.5,244.5C 491.376,244.369 492.043,244.702 492.5,245.5C 489.855,249.476 486.855,253.143 483.5,256.5C 478.068,259.3 472.568,261.966 467,264.5C 464.937,279.69 460.27,294.023 453,307.5C 443.067,324.967 428.067,334.3 408,335.5C 388.913,334.75 371.746,328.75 356.5,317.5C 354.167,314.5 351.5,311.833 348.5,309.5C 345.828,305.313 343.328,300.98 341,296.5C 335.579,279.659 335.079,262.659 339.5,245.5C 344.155,237.486 342.822,236.486 335.5,242.5C 334.033,243.292 332.7,243.292 331.5,242.5C 336.026,237.292 341.359,233.292 347.5,230.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#310303",
    d: "M 514.5,226.5 C 513.54,231.086 511.54,235.086 508.5,238.5C 509.992,234.182 511.992,230.182 514.5,226.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0c0000",
    d: "M 393.5,264.5 C 393.682,262.409 393.348,260.409 392.5,258.5C 393.347,257.155 394.513,256.155 396,255.5C 397.842,257.546 399.009,259.88 399.5,262.5C 401.361,267.227 403.528,271.893 406,276.5C 409.37,273.465 412.37,270.132 415,266.5C 422.814,277.964 428.314,290.464 431.5,304C 428.724,308.127 425.89,312.293 423,316.5C 421.855,314.074 420.522,311.741 419,309.5C 412.567,315.095 407.067,321.428 402.5,328.5C 400.926,329.631 399.259,329.798 397.5,329C 399.382,321.775 398.382,314.942 394.5,308.5C 387.831,313.336 381.998,319.002 377,325.5C 375.5,325 374,324.5 372.5,324C 377.098,317.441 378.431,310.275 376.5,302.5C 369.523,304.707 363.189,308.04 357.5,312.5C 356.5,312.167 355.833,311.5 355.5,310.5C 361.051,304.768 363.717,298.101 363.5,290.5C 358.447,291.256 353.447,292.256 348.5,293.5C 347.522,293.189 346.855,292.522 346.5,291.5C 351.727,287.894 355.393,283.061 357.5,277C 357.43,276.235 357.097,275.735 356.5,275.5C 354.901,275.768 353.568,275.434 352.5,274.5C 349.642,273.834 346.642,273.167 343.5,272.5C 344.901,271.479 346.235,270.479 347.5,269.5C 350.785,266.882 353.785,263.882 356.5,260.5C 354.581,259.388 352.914,258.054 351.5,256.5C 349.22,254.777 346.553,254.111 343.5,254.5C 343.5,252.833 343.5,251.167 343.5,249.5C 343.485,245.44 343.985,241.44 345,237.5C 347.382,236.446 349.882,235.779 352.5,235.5C 353.155,241.464 354.821,247.131 357.5,252.5C 362.064,250.037 365.231,246.371 367,241.5C 368.966,245.925 370.3,250.591 371,255.5C 372.405,259.217 373.905,262.883 375.5,266.5C 379.187,263.647 382.353,260.314 385,256.5C 386.244,259.982 388.244,262.982 391,265.5C 392.162,270.792 393.162,276.125 394,281.5C 394.689,284.408 395.855,287.075 397.5,289.5C 399.39,286.048 399.89,282.382 399,278.5C 397.406,273.66 395.572,268.993 393.5,264.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#200402",
    d: "M 354.5,235.5 C 357.967,237.067 361.3,238.901 364.5,241C 362.333,243.833 360.167,246.667 358,249.5C 357.142,244.735 355.976,240.069 354.5,235.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#340403",
    d: "M 339.5,245.5 C 339.87,241.814 338.537,240.814 335.5,242.5C 342.822,236.486 344.155,237.486 339.5,245.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#380505",
    d: "M 210.5,241.5 C 208.327,245.852 205.66,249.852 202.5,253.5C 204.178,248.803 206.844,244.803 210.5,241.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#330403",
    d: "M 277.5,246.5 C 274.833,249.833 271.833,252.833 268.5,255.5C 270.5,251.5 273.5,248.5 277.5,246.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1d0301",
    d: "M 370.5,243.5 C 375.43,245.757 380.43,247.924 385.5,250C 382.333,254.5 379.167,259 376,263.5C 374.479,256.75 372.646,250.084 370.5,243.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#330403",
    d: "M 497.5,238.5 C 493.251,247.339 488.251,255.672 482.5,263.5C 482.962,261.243 483.962,259.243 485.5,257.5C 485.043,256.702 484.376,256.369 483.5,256.5C 486.855,253.143 489.855,249.476 492.5,245.5C 492.043,244.702 491.376,244.369 490.5,244.5C 491.718,243.839 493.051,243.172 494.5,242.5C 495.035,240.739 496.035,239.406 497.5,238.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#330404",
    d: "M 182.5,252.5 C 183.331,263.659 183.831,274.993 184,286.5C 184.278,285.584 184.778,284.918 185.5,284.5C 184.64,287.911 183.474,291.244 182,294.5C 182.428,280.544 182.595,266.544 182.5,252.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#380405",
    d: "M 343.5,249.5 C 343.5,251.167 343.5,252.833 343.5,254.5C 346.553,254.111 349.22,254.777 351.5,256.5C 348.545,255.841 345.545,255.508 342.5,255.5C 342.205,253.265 342.539,251.265 343.5,249.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#380504",
    d: "M 399.5,262.5 C 399.009,259.88 397.842,257.546 396,255.5C 394.513,256.155 393.347,257.155 392.5,258.5C 393.348,260.409 393.682,262.409 393.5,264.5C 392.731,262.333 391.731,260.166 390.5,258C 396.877,252.521 399.877,254.021 399.5,262.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1e0301",
    d: "M 342.5,257.5 C 345.879,258.606 349.213,259.773 352.5,261C 349.5,262.833 346.5,264.667 343.5,266.5C 342.516,263.572 342.183,260.572 342.5,257.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1e0301",
    d: "M 400.5,257.5 C 400.56,256.957 400.893,256.624 401.5,256.5C 405.711,258.626 410.044,260.459 414.5,262C 411.301,265.566 408.467,269.4 406,273.5C 405.032,267.759 403.198,262.425 400.5,257.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1f0301",
    d: "M 420.5,264.5 C 420.56,263.957 420.893,263.624 421.5,263.5C 425.135,264.606 428.802,265.606 432.5,266.5C 430,270.167 427.5,273.833 425,277.5C 423.943,272.899 422.443,268.566 420.5,264.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2b0502",
    d: "M 461.5,264.5 C 462.239,264.369 462.906,264.536 463.5,265C 462.266,268.2 460.933,271.367 459.5,274.5C 458.501,271.839 457.501,269.172 456.5,266.5C 458.291,265.83 459.958,265.163 461.5,264.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1f0301",
    d: "M 439.5,266.5 C 442.85,266.335 446.183,266.502 449.5,267C 446.954,270.59 444.787,274.423 443,278.5C 441.829,274.482 440.663,270.482 439.5,266.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f03030",
    d: "M 227.5,328.5 C 227.918,329.222 228.584,329.722 229.5,330C 225.179,330.499 220.846,330.666 216.5,330.5C 212.86,329.727 209.193,329.06 205.5,328.5C 204.164,326.99 202.997,325.323 202,323.5C 201.501,319.514 201.334,315.514 201.5,311.5C 203.674,295.975 209.008,281.642 217.5,268.5C 217.833,268.833 218.167,269.167 218.5,269.5C 212.607,286.731 209.107,304.397 208,322.5C 214.271,325.193 220.771,327.193 227.5,328.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#390505",
    d: "M 347.5,269.5 C 346.235,270.479 344.901,271.479 343.5,272.5C 346.642,273.167 349.642,273.834 352.5,274.5C 349.167,274.5 345.833,274.5 342.5,274.5C 342.162,270.849 343.828,269.183 347.5,269.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#200401",
    d: "M 342.5,277.5 C 346.182,277.335 349.848,277.501 353.5,278C 350,280.167 347.167,283 345,286.5C 343.745,283.662 342.911,280.662 342.5,277.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#350404",
    d: "M 356.5,275.5 C 357.097,275.735 357.43,276.235 357.5,277C 355.393,283.061 351.727,287.894 346.5,291.5C 346.855,292.522 347.522,293.189 348.5,293.5C 347.811,294.774 346.977,294.774 346,293.5C 345.333,292.167 345.333,290.833 346,289.5C 351.198,286.103 354.698,281.436 356.5,275.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f03030",
    d: "M 196.5,300.5 C 193.44,314.55 191.94,328.883 192,343.5C 192.5,344.667 193.333,345.5 194.5,346C 200.297,347.059 205.964,348.559 211.5,350.5C 204.496,351.676 197.496,351.676 190.5,350.5C 189.164,348.99 187.997,347.323 187,345.5C 186.5,338.508 186.334,331.508 186.5,324.5C 188.181,316.443 190.181,308.443 192.5,300.5C 193.892,298.727 195.059,296.727 196,294.5C 196.495,296.473 196.662,298.473 196.5,300.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1f0301",
    d: "M 358.5,293.5 C 359.552,293.351 360.552,293.517 361.5,294C 358.541,298.751 355.707,303.584 353,308.5C 351.294,304.921 349.461,301.421 347.5,298C 351.449,296.943 355.116,295.443 358.5,293.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#340403",
    d: "M 196.5,300.5 C 196.662,298.473 196.495,296.473 196,294.5C 195.059,296.727 193.892,298.727 192.5,300.5C 192.499,296.794 194.165,294.461 197.5,293.5C 197.802,296.059 197.468,298.393 196.5,300.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#210301",
    d: "M 445.5,295.5 C 446.641,298.64 446.808,301.973 446,305.5C 444,308.167 442,310.833 440,313.5C 439.713,311.109 439.213,308.776 438.5,306.5C 441.604,303.284 443.937,299.618 445.5,295.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1c0301",
    d: "M 373.5,305.5 C 373.762,311.009 372.762,316.509 370.5,322C 369.092,322.315 367.759,321.982 366.5,321C 363.833,319 361.167,317 358.5,315C 364.209,312.76 369.209,309.593 373.5,305.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1e0301",
    d: "M 434.5,305.5 C 435.54,309.347 436.04,313.347 436,317.5C 432.015,320.993 427.682,323.993 423,326.5C 423.053,324.212 423.386,321.879 424,319.5C 428.102,315.239 431.602,310.572 434.5,305.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2f0302",
    d: "M 348.5,309.5 C 351.5,311.833 354.167,314.5 356.5,317.5C 352.833,315.833 350.167,313.167 348.5,309.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1b0201",
    d: "M 392.5,312.5 C 393.222,312.918 393.722,313.584 394,314.5C 394.501,319.508 395.001,324.508 395.5,329.5C 390.347,328.975 385.347,327.808 380.5,326C 385.079,321.926 389.079,317.426 392.5,312.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1c0301",
    d: "M 417.5,312.5 C 419.362,317.293 419.695,322.293 418.5,327.5C 414.263,329.406 409.929,329.739 405.5,328.5C 410.492,323.822 414.492,318.489 417.5,312.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#300303",
    d: "M 201.5,311.5 C 201.334,315.514 201.501,319.514 202,323.5C 202.997,325.323 204.164,326.99 205.5,328.5C 203.248,328.084 201.748,326.751 201,324.5C 200.186,319.98 200.353,315.646 201.5,311.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#360404",
    d: "M 458.5,326.5 C 458.139,330.915 456.806,334.915 454.5,338.5C 455.261,334.216 456.595,330.216 458.5,326.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#340403",
    d: "M 227.5,328.5 C 228.5,328.5 229.5,328.5 230.5,328.5C 230.5,329.5 230.5,330.5 230.5,331.5C 225.637,331.819 220.97,331.486 216.5,330.5C 220.846,330.666 225.179,330.499 229.5,330C 228.584,329.722 227.918,329.222 227.5,328.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3f0506",
    d: "M 186.5,324.5 C 186.334,331.508 186.5,338.508 187,345.5C 187.997,347.323 189.164,348.99 190.5,350.5C 188.248,350.084 186.748,348.751 186,346.5C 185.178,338.988 185.345,331.655 186.5,324.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#340403",
    d: "M 462.5,340.5 C 461.207,345.753 458.874,350.419 455.5,354.5C 457.326,349.516 459.659,344.849 462.5,340.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#380404",
    d: "M 230.5,358.5 C 229.282,359.161 227.949,359.828 226.5,360.5C 225.248,364.678 223.248,368.345 220.5,371.5C 222.154,367.521 223.821,363.521 225.5,359.5C 227.045,358.548 228.712,358.215 230.5,358.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3b0506",
    d: "M 169.5,359.5 C 169.468,364.391 168.801,369.057 167.5,373.5C 167.362,368.586 168.028,363.919 169.5,359.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#320403",
    d: "M 220.5,360.5 C 218.113,368.888 213.113,375.222 205.5,379.5C 211.674,374.004 216.674,367.671 220.5,360.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2e0302",
    d: "M 163.5,371.5 C 164.134,379.903 163.467,387.903 161.5,395.5C 162.138,387.401 162.805,379.401 163.5,371.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#340403",
    d: "M 183.5,383.5 C 179.833,389.167 175.167,393.833 169.5,397.5C 173.833,392.5 178.5,387.833 183.5,383.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0b0000",
    d: "M 437.5,396.5 C 441.819,399.996 446.485,402.996 451.5,405.5C 453.749,406.08 455.415,407.413 456.5,409.5C 462.167,415.833 468.167,421.833 474.5,427.5C 484.454,438.135 492.454,450.135 498.5,463.5C 501.739,471.647 505.739,479.314 510.5,486.5C 511.674,487.514 512.34,488.847 512.5,490.5C 512.631,491.239 512.464,491.906 512,492.5C 511.578,490.574 510.411,489.574 508.5,489.5C 501.87,481.726 493.537,476.56 483.5,474C 481.391,472.859 479.558,471.359 478,469.5C 474.24,461.475 471.24,453.141 469,444.5C 464.255,434.776 456.422,429.276 445.5,428C 438.41,415.785 427.743,409.785 413.5,410C 411.579,409.64 409.912,408.806 408.5,407.5C 414.125,402.343 419.792,397.176 425.5,392C 430.027,392.097 434.027,393.597 437.5,396.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#350404",
    d: "M 588.5,407.5 C 588.586,405.323 589.253,403.323 590.5,401.5C 590.167,401.167 589.833,400.833 589.5,400.5C 586.607,402.445 583.607,404.111 580.5,405.5C 584.332,401.655 588.832,398.655 594,396.5C 592.737,400.36 590.903,404.027 588.5,407.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#350404",
    d: "M 437.5,396.5 C 442.855,398.506 447.521,401.506 451.5,405.5C 446.485,402.996 441.819,399.996 437.5,396.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#080000",
    d: "M 588.5,407.5 C 575.88,443.141 564.88,479.307 555.5,516C 555.095,516.945 554.428,517.612 553.5,518C 538.542,520.188 536.708,526.021 548,535.5C 549.564,547.278 551.73,558.945 554.5,570.5C 554.851,572.869 555.018,575.203 555,577.5C 552.913,576.206 550.746,575.039 548.5,574C 547.177,573.184 546.511,572.017 546.5,570.5C 548.917,559.834 545.251,552.001 535.5,547C 531.943,545.592 528.276,544.592 524.5,544C 518.751,543.852 513.085,543.186 507.5,542C 503.86,535.687 498.527,531.687 491.5,530C 489.5,529.333 487.5,529.333 485.5,530C 481.385,535.165 476.052,536.832 469.5,535C 463.295,532.121 457.628,528.454 452.5,524C 448.952,522.059 445.286,520.393 441.5,519C 430.141,516.759 418.807,514.425 407.5,512C 401.068,509.902 397.068,505.568 395.5,499C 390.098,497.313 384.764,495.813 379.5,494.5C 376.495,491.359 374.828,487.693 374.5,483.5C 373.197,481.858 371.864,480.191 370.5,478.5C 369.016,475.416 369.182,472.416 371,469.5C 373.848,466.848 377.015,464.848 380.5,463.5C 381.117,463.389 381.617,463.056 382,462.5C 384.231,469.395 388.064,475.229 393.5,480C 401.098,485.626 409.098,490.46 417.5,494.5C 423.849,498.341 430.516,501.675 437.5,504.5C 449.023,509.506 461.023,513.006 473.5,515C 483.361,516.083 493.028,515.249 502.5,512.5C 508.857,519.178 516.524,523.511 525.5,525.5C 529.658,525.592 531.991,523.592 532.5,519.5C 531.649,515.759 530.649,512.092 529.5,508.5C 526.5,501.167 523.5,493.833 520.5,486.5C 520.328,485.508 520.662,484.842 521.5,484.5C 524.341,480.151 526.674,475.484 528.5,470.5C 535.852,455.115 545.185,441.115 556.5,428.5C 563.167,422.5 569.5,416.167 575.5,409.5C 576.585,407.413 578.251,406.08 580.5,405.5C 583.607,404.111 586.607,402.445 589.5,400.5C 589.833,400.833 590.167,401.167 590.5,401.5C 589.253,403.323 588.586,405.323 588.5,407.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#340403",
    d: "M 167.5,404.5 C 165.167,407.5 162.5,410.167 159.5,412.5C 161.167,408.833 163.833,406.167 167.5,404.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#320403",
    d: "M 572.5,403.5 C 567.833,408.833 562.833,413.833 557.5,418.5C 561.5,412.5 566.5,407.5 572.5,403.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#320403",
    d: "M 456.5,409.5 C 463.5,414.5 469.5,420.5 474.5,427.5C 468.167,421.833 462.167,415.833 456.5,409.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#310303",
    d: "M 575.5,409.5 C 569.5,416.167 563.167,422.5 556.5,428.5C 561.833,421.167 568.167,414.833 575.5,409.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#300303",
    d: "M 168.5,410.5 C 163.11,416.892 157.11,422.559 150.5,427.5C 155.89,421.108 161.89,415.441 168.5,410.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#330403",
    d: "M 158.5,413.5 C 155.437,417.566 151.771,420.899 147.5,423.5C 150.563,419.434 154.229,416.101 158.5,413.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#340403",
    d: "M 394.5,417.5 C 391.086,420.54 387.086,422.54 382.5,423.5C 386.182,420.992 390.182,418.992 394.5,417.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2f0302",
    d: "M 121.5,423.5 C 116.167,429.5 110.5,435.167 104.5,440.5C 109.167,433.833 114.833,428.167 121.5,423.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#320403",
    d: "M 454.5,433.5 C 459.32,434.321 462.653,436.988 464.5,441.5C 461.431,438.423 458.097,435.756 454.5,433.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#310303",
    d: "M 120.5,448.5 C 118.234,452.436 115.234,455.769 111.5,458.5C 113.766,454.564 116.766,451.231 120.5,448.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#460708",
    d: "M 107.5,445.5 C 105.5,448.167 103.167,450.5 100.5,452.5C 101.833,449.167 104.167,446.833 107.5,445.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#320403",
    d: "M 107.5,457.5 C 103.773,462.23 99.4397,466.23 94.5,469.5C 98.2269,464.77 102.56,460.77 107.5,457.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#350404",
    d: "M 532.5,454.5 C 529.675,461.484 526.341,468.151 522.5,474.5C 524.793,467.248 528.126,460.581 532.5,454.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#360404",
    d: "M 380.5,463.5 C 377.015,464.848 373.848,466.848 371,469.5C 369.182,472.416 369.016,475.416 370.5,478.5C 367.021,469.564 370.355,464.564 380.5,463.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0b0000",
    d: "M 448.5,478.5 C 452.182,481.008 456.182,483.008 460.5,484.5C 472.81,489.985 484.144,496.985 494.5,505.5C 494.511,507.017 495.177,508.184 496.5,509C 493.518,509.498 490.518,509.665 487.5,509.5C 463.417,507.305 440.417,501.138 418.5,491C 411.167,485.667 403.833,480.333 396.5,475C 391.833,471.667 387.833,467.667 384.5,463C 407.267,462.65 428.6,467.816 448.5,478.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#360404",
    d: "M 429.5,463.5 C 433.915,463.861 437.915,465.194 441.5,467.5C 437.216,466.739 433.216,465.405 429.5,463.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#360404",
    d: "M 189.5,474.5 C 187.174,471.865 184.841,469.198 182.5,466.5C 180.271,467.577 177.937,468.244 175.5,468.5C 178.087,466.362 181.087,465.529 184.5,466C 186.568,468.642 188.235,471.475 189.5,474.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3b0505",
    d: "M 498.5,463.5 C 503.261,470.686 507.261,478.353 510.5,486.5C 505.739,479.314 501.739,471.647 498.5,463.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#310303",
    d: "M 191.5,465.5 C 191.34,467.199 191.506,468.866 192,470.5C 194.08,473.065 195.913,475.732 197.5,478.5C 191.868,475.584 189.868,471.25 191.5,465.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#320303",
    d: "M 509.5,467.5 C 512.5,472.833 515.5,478.167 518.5,483.5C 518.649,484.552 518.483,485.552 518,486.5C 514.6,480.371 511.766,474.037 509.5,467.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#320303",
    d: "M 145.5,473.5 C 139.151,477.341 132.484,480.675 125.5,483.5C 131.581,479.126 138.248,475.793 145.5,473.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#390505",
    d: "M 528.5,470.5 C 526.674,475.484 524.341,480.151 521.5,484.5C 522.793,479.247 525.126,474.581 528.5,470.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#300303",
    d: "M 161.5,474.5 C 157.584,477.29 153.251,479.29 148.5,480.5C 152.416,477.71 156.749,475.71 161.5,474.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3c0506",
    d: "M 448.5,478.5 C 453.086,479.46 457.086,481.46 460.5,484.5C 456.182,483.008 452.182,481.008 448.5,478.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4d0709",
    d: "M 200.5,482.5 C 203.427,483.757 205.761,485.757 207.5,488.5C 204.573,487.243 202.239,485.243 200.5,482.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#360404",
    d: "M 146.5,481.5 C 142.653,484.593 138.32,486.926 133.5,488.5C 137.347,485.407 141.68,483.074 146.5,481.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2f0302",
    d: "M 199.5,486.5 C 204.833,491.167 209.833,496.167 214.5,501.5C 208.5,497.5 203.5,492.5 199.5,486.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#320403",
    d: "M 374.5,483.5 C 374.828,487.693 376.495,491.359 379.5,494.5C 377.248,494.084 375.748,492.751 375,490.5C 374.503,488.19 374.337,485.857 374.5,483.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#380404",
    d: "M 520.5,486.5 C 523.5,493.833 526.5,501.167 529.5,508.5C 526.108,502.72 522.941,496.72 520,490.5C 519.235,488.934 519.402,487.601 520.5,486.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3a0505",
    d: "M 417.5,494.5 C 424.752,496.793 431.419,500.126 437.5,504.5C 430.516,501.675 423.849,498.341 417.5,494.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2d0503",
    d: "M 508.5,489.5 C 510.411,489.574 511.578,490.574 512,492.5C 512.464,491.906 512.631,491.239 512.5,490.5C 516.734,495.64 519.9,501.307 522,507.5C 519.708,506.21 517.708,504.543 516,502.5C 513.488,498.139 510.988,493.806 508.5,489.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#350404",
    d: "M 494.5,505.5 C 496.296,506.793 497.963,508.293 499.5,510C 495.311,510.812 491.311,510.645 487.5,509.5C 490.518,509.665 493.518,509.498 496.5,509C 495.177,508.184 494.511,507.017 494.5,505.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#300302",
    d: "M 417.5,517.5 C 417.062,517.435 416.728,517.601 416.5,518C 418.79,519.777 420.457,521.944 421.5,524.5C 418.703,522.205 416.036,519.705 413.5,517C 415.066,516.235 416.399,516.402 417.5,517.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#350404",
    d: "M 407.5,515.5 C 408.833,515.5 410.167,515.5 411.5,515.5C 412.542,519.919 413.875,524.252 415.5,528.5C 412.754,525.001 411.087,521.001 410.5,516.5C 409.209,516.737 408.209,516.404 407.5,515.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#390505",
    d: "M 514.5,517.5 C 517.691,518.896 521.024,519.896 524.5,520.5C 526.03,520.36 527.03,519.693 527.5,518.5C 528.404,519.209 528.737,520.209 528.5,521.5C 525.813,521.664 523.146,521.497 520.5,521C 517.975,520.576 515.975,519.41 514.5,517.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#370404",
    d: "M 375.5,524.5 C 375.709,525.922 376.209,527.255 377,528.5C 380.038,531.369 382.871,534.369 385.5,537.5C 381.933,535.443 378.766,532.777 376,529.5C 374.546,527.756 374.379,526.089 375.5,524.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3b0506",
    d: "M 250.5,527.5 C 255.32,529.074 259.653,531.407 263.5,534.5C 258.68,532.926 254.347,530.593 250.5,527.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#330403",
    d: "M 386.5,529.5 C 390.542,530.851 393.875,533.185 396.5,536.5C 392.808,534.656 389.475,532.323 386.5,529.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#360404",
    d: "M 490.5,534.5 C 488.068,535.75 485.734,537.25 483.5,539C 482.207,539.49 480.873,539.657 479.5,539.5C 482.587,538.443 485.254,536.609 487.5,534C 488.749,533.26 489.749,533.427 490.5,534.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#350404",
    d: "M 490.5,534.5 C 492.655,534.372 494.655,534.872 496.5,536C 499.863,539.252 502.863,542.752 505.5,546.5C 504.761,546.631 504.094,546.464 503.5,546C 500.187,540.844 495.854,537.011 490.5,534.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0d0000",
    d: "M 349.5,557.5 C 358.848,557.668 368.181,558.168 377.5,559C 379.294,565.025 379.794,571.192 379,577.5C 373.848,580.175 368.681,580.008 363.5,577C 357.426,571.439 352.76,564.939 349.5,557.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#340404",
    d: "M 396.5,557.5 C 392.316,558.166 387.982,558.833 383.5,559.5C 387.357,565.885 388.357,572.552 386.5,579.5C 387.503,571.86 385.836,564.86 381.5,558.5C 386.456,557.506 391.456,557.173 396.5,557.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#340403",
    d: "M 546.5,570.5 C 546.511,572.017 547.177,573.184 548.5,574C 550.746,575.039 552.913,576.206 555,577.5C 555.018,575.203 554.851,572.869 554.5,570.5C 556.431,573.275 557.097,576.275 556.5,579.5C 553.5,578 550.5,576.5 547.5,575C 545.534,573.653 545.201,572.153 546.5,570.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#310303",
    d: "M 529.5,591.5 C 533.566,594.563 536.899,598.229 539.5,602.5C 535.434,599.437 532.101,595.771 529.5,591.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#310403",
    d: "M 570.5,592.5 C 574.008,598.182 577.008,604.182 579.5,610.5C 575.46,605.086 572.46,599.086 570.5,592.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#380505",
    d: "M 532.5,601.5 C 540.833,609.167 548.833,617.167 556.5,625.5C 548.255,618.76 540.422,611.427 533,603.5C 532.536,602.906 532.369,602.239 532.5,601.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#330404",
    d: "M 547.5,610.5 C 551.436,612.766 554.769,615.766 557.5,619.5C 553.564,617.234 550.231,614.234 547.5,610.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#330504",
    d: "M 581.5,614.5 C 585.161,618.825 587.494,623.825 588.5,629.5C 585.93,624.689 583.597,619.689 581.5,614.5 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSh7);
export default __webpack_public_path__ + "static/media/sh7.2b2c4b3e2b7ddef3420b41b9d5a0eb8c.svg";
export { ForwardRef as ReactComponent };